import React from "react";
import { withRouter, RouteComponentProps } from "react-router";
import Dropdown from "../Dropdown";
import SignOutDropdownButton from "./SignOutDropdownButton";
import companyInfo from "../../../utils/companyInfo";

interface State {
  settingsMenuIsActive: boolean;
}

interface OwnProps {
  location: Location;
}

type Props = RouteComponentProps & OwnProps;

class ToolbarSettings extends React.PureComponent<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      settingsMenuIsActive: false
    }
  }

  /**
   * Toggle the settingsMenuIsActive state.
   */
  toggleSettingsMenuState = () => {
    this.setState({ settingsMenuIsActive: !this.state.settingsMenuIsActive });
  }

  /**
   * Set the settingsMenuIsActive state to false.
   */
  hideSettingsMenu = () => {
    this.setState({ settingsMenuIsActive: false });
  }

  render() {
    return (
      <div className="component--toolbar-settings">
        <Dropdown
          isActive={this.state.settingsMenuIsActive}
          onClick={this.toggleSettingsMenuState}
          onBlur={this.hideSettingsMenu}
          toggleButton={
            <div className="user-settings-menu">
              <div className="toggle-dropdown">
                <div className={`menu-button ${this.state.settingsMenuIsActive ? "active" : ""}`} />
              </div>
            </div>
          }
        >
          {this.props.children}

          {/* TODO: Using prevent default on mouse down is a hack to avoid a racing condition between the anchor tag href and the onBlur
          event on dropdown. This should be further investigated and fixed. */}
          <li key="cities" onMouseDown={(e) => e.preventDefault()}>
            <a href={companyInfo.CITIES_URL} target="_blank" rel="noreferrer noopener" className="button">Cities with Data</a>
          </li>
          <li key="webinar" onMouseDown={(e) => e.preventDefault()}>
            <a href={companyInfo.WEBINAR_URL} target="_blank" rel="noreferrer noopener" className="button">Weekly Webinar</a>
          </li>
          <li key="tutorials" onMouseDown={(e) => e.preventDefault()}>
            <a href={companyInfo.TUTORIALS_URL} target="_blank" rel="noreferrer noopener" className="button">Product Tutorials</a>
          </li>
          <li key="blog" onMouseDown={(e) => e.preventDefault()}>
            <a href={companyInfo.BLOG_URL} target="_blank" rel="noreferrer noopener" className="button">Blog</a>
          </li>
          <li key="contact-us" onMouseDown={(e) => e.preventDefault()}>
            <a href={companyInfo.CONTACT_US_URL} target="_blank" rel="noreferrer noopener" className="button">Contact Us</a>
          </li>
          <SignOutDropdownButton />
        </Dropdown>
      </div>
    )
  }
}

export default withRouter(ToolbarSettings);
